import * as Constants from '../services/Constants'
import { persistent } from '../services/LocalStorage'
import { Dialog } from '@/components/Dialog'
import { Button } from '@/UIComponents2/Button'

function FirstTimeMidiOffPopup({ show, onClose }: { show: boolean; onClose: (ignoreAndContinue: boolean) => void }) {
    return (
        <Dialog
            title="MIDI Device Warning"
            open={show}
            onClose={() => onClose(false)}
            portaled={false}
            zIndex={21}
            className="pt-[40px] w-[500px] flex flex-col gap-8"
        >
            <div className="text-[1.25rem] font-medium">MIDI Device Warning</div>

            <div>You need to close Muse completely before other programs can access your MIDI devices again.</div>

            <div className="grid grid-cols-2 gap-1">
                <Button
                    variant="secondary"
                    className="py-[10px] w-full"
                    onClick={() => {
                        persistent.set(Constants.notifications_suppress_midi_off_notice, true)
                        onClose(true)
                    }}
                >
                    Don't show again
                </Button>
                <Button variant="primary" className="py-[10px] w-full" onClick={() => onClose(false)}>
                    OK
                </Button>
            </div>
        </Dialog>
    )
}

export default FirstTimeMidiOffPopup
